export default __webpack_public_path__ + "static/media/robos.a5710d8e.png";